import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faSpinner, faUser } from '@fortawesome/free-solid-svg-icons';
import axiosInstance from './utils/axiosinstance';
import AnnotationTab from './AnnotationTab';
import ReviewerAccessPanel from './ReviewerAccessPanel';

// Admin-only Results view: pick an annotator, then browse the Review list
// exactly as they see it, with their marks shown read-only. Also offers the
// DPO verdicts export across all annotators.
const AdminResultsTab = () => {
    const [annotators, setAnnotators] = useState([]);
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    const [includeUnfinished, setIncludeUnfinished] = useState(false);

    useEffect(() => {
        axiosInstance.get('/api/admin/annotators/')
            .then((r) => {
                const list = r.data.annotators || [];
                setAnnotators(list);
                if (list.length) setSelected(list[0].id);
            })
            .catch((e) => console.error('Error loading annotators:', e))
            .finally(() => setLoading(false));
    }, []);

    const exportUrl = `/api/admin/export_verdicts/${includeUnfinished ? '?include_unfinished=1' : ''}`;

    if (loading) {
        return (
            <div className="flex justify-center py-24 text-white text-4xl">
                <FontAwesomeIcon icon={faSpinner} spin />
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-3">
            <ReviewerAccessPanel />
            <div className="flex flex-wrap items-center gap-3 bg-white bg-opacity-10 rounded-lg p-3">
                <FontAwesomeIcon icon={faUser} className="text-white" />
                <select
                    value={selected || ''}
                    onChange={(e) => setSelected(Number(e.target.value))}
                    className="rounded-full px-4 h-11 bg-black bg-opacity-30 text-white outline-none"
                >
                    {annotators.map((a) => (
                        <option key={a.id} value={a.id} className="text-black">
                            {a.username} — {a.done}/{a.annotated} done
                        </option>
                    ))}
                </select>
                {annotators.length === 0 && (
                    <span className="text-white text-opacity-70 text-sm">No annotations yet.</span>
                )}

                <span className="flex-1" />

                <label className="flex items-center gap-2 text-white text-sm cursor-pointer">
                    <input
                        type="checkbox"
                        checked={includeUnfinished}
                        onChange={(e) => setIncludeUnfinished(e.target.checked)}
                    />
                    Include videos not marked done
                </label>
                <a
                    href={exportUrl}
                    className="flex items-center gap-2 px-5 h-11 rounded-full bg-sil-blue-500 hover:bg-sil-blue-600 text-white font-semibold"
                    title="Download DPO verdicts JSON (all annotators merged)"
                >
                    <FontAwesomeIcon icon={faDownload} />
                    DPO verdicts JSON
                </a>
            </div>

            {selected && (
                // key forces a fresh load per annotator
                <AnnotationTab key={selected} readOnly annotatorId={selected} />
            )}
        </div>
    );
};

export default AdminResultsTab;
